import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'urlencode',
  standalone: false
})
export class UrlencodePipe implements PipeTransform {
  constructor() {}
  transform(value: any): string {
    if (value == null || typeof value !== 'object') return '';

    const encode = (obj: any, prefix?: string): string[] => {
      return Object.keys(obj).flatMap(key => {
        const val = obj[key];
        const fullKey = prefix ? `${prefix}[${key}]` : key;

        if (val === null || val === undefined) {
          return `${encodeURIComponent(fullKey)}=`;
        } else if (typeof val === 'object' && !Array.isArray(val)) {
          return encode(val, fullKey);
        } else {
          return `${encodeURIComponent(fullKey)}=${encodeURIComponent(val)}`;
        }
      });
    };

    return encode(value).join('&');
  }
}
